import { observable, action, when } from 'mobx';
import { analytics } from 'core/analytics';
import { routerStore } from 'core/routing';
import { ComponentRegistry } from 'core/registry';

import { clientStore } from 'apps/client/app';

class ModalStore {
  @observable component = '';
  @observable fadedIn = false;

  @action SetModalComponent = (component, props = {}, onClose = null) => {
    const ResetPasswordModal = ComponentRegistry.get(
      'modals.ResetPasswordModal',
    );
    const AccessForm = ComponentRegistry.get('modals.AccessForm');
    const NoRobotsModal = ComponentRegistry.get('modals.NoRobotsModal');
    const SignUpModal = ComponentRegistry.get('modals.SignUpModal');
    const SignInModal = ComponentRegistry.get('modals.SignInModal');
    const signedOutModals = [
      ResetPasswordModal,
      AccessForm,
      NoRobotsModal,
      SignUpModal,
      SignInModal,
    ];
    if (clientStore.signedInProfile == null) {
      if (!signedOutModals.includes(component)) {
        // Certain modals should require authentication e.g. newIssueModal,
        // in those cases we redirect if not authenticated
        routerStore.navigate('home.signIn', { next: clientStore.next() });
        return;
      }
    }
    this.component = component;

    const componentName = component.displayName
      ? component.displayName.replace(/(withNamespaces\(|\))/g, '')
      : component.name;

    analytics.sendEvent('modal-view', { name: componentName });
    this.props = props;
    this.onClose = onClose;
    const routeName = routerStore.route.name;
    when(
      () => routerStore.route.name !== routeName,
      () => this.ClearComponent(),
    );
  };

  @action FadeIn = () => {
    this.fadedIn = true;
  };

  @action Close = arg => {
    this.ClearComponent();
    this.large = false;
    if (this.onClose) {
      this.onClose(arg);
      this.onClose = null;
    }
  };

  @observable large = false;
  @action SetLarge = bool => {
    this.large = bool;
  };

  @action ClearComponent = () => {
    this.component = '';
    this.props = {};
    this.fadedIn = false;
  };
}

export const modalStore = new ModalStore();
